<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="cust_name" [ttModel]="edit.cust_name" ttReadonly></tt-input>
        <tt-input ttLabel="cust_adr_street" [ttModel]="edit.cust_adr_street" ttReadonly></tt-input>
        <tt-input ttLabel="postplace_id_street" [ttModel]="edit.postplace_id_street" ttReadonly></tt-input>
        <tt-input ttLabel="org_no" [ttModel]="edit.org_no" ttReadonly></tt-input>
        <tt-input ttLabel="nace_code" [ttModel]="edit.nace_code" ttReadonly></tt-input>
        <tt-textarea ttLabel="nace_description" [ttModel]="edit.nace_description" ttReadonly></tt-textarea>

        <div *ngIf="edit.sr === '0'">
            <tt-select ttLabel="custgrp" [(ttModel)]="edit.custgrp_id" [ttData]="selectListCustomerGroups" ttDataId="custgrp_id" ttDataName="custgrp_name" [ttButtons]="customerGroupButtons" ttRequired></tt-select>
            <tt-select ttLabel="business" [(ttModel)]="edit.cust_business_id" [ttData]="selectListBusinesses" ttDataId="business_id" ttDataName="business_name" [ttButtons]="customerBusinessButtons" ttRequired></tt-select>
        </div>

        <tt-button ttText="brregview_companyinfo" (ttClick)="openWebLink()" ttIcon="fa fa-window-restore"></tt-button>
        <tt-button-save ttText="brregview_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
